import { init, setTag } from '@sentry/svelte';
import { browser } from '$app/environment';
import { PUBLIC_SENTRY_DSN, PUBLIC_ENVIRONMENT } from '$env/static/public';

// https://github.com/getsentry/sentry-javascript/issues/6173#issuecomment-1385065719
const ignorableErrors = [
    /This Suspense boundary received an update before it finished hydrating\..+/,
    /Minified React error #421.+/,
    /This root received an early update, before anything was able hydrate\..+/,
    /window\._kbc.+/,
    /Can't find variable: FS.*/
];

export const useFrontendSentry = () => {
    if (browser) {
        init({
            environment: PUBLIC_ENVIRONMENT,
            release: `fabric-spine-v2@${__VERSION__}`,
            dsn: `${PUBLIC_SENTRY_DSN}`,
            allowUrls: [/https:\/\/.*(fabric|casumo).*/],
            beforeSend(event, hint) {
                const errorMsg = hint.originalException?.toString();
                if (errorMsg && ignorableErrors.some((regex) => regex.test(errorMsg))) {
                    return null;
                }
                return event;
            }
        });
        setTag('platform', 'frontend');
    }
};
